export default function Footer() {
  return (
    <footer className="w-full bg-accent-950 text-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="font-heading font-bold text-lg tracking-widest text-background-50">
                LRGS1 X9PRO
              </span>
            </div>
            <p className="mt-5 text-sm text-background-300 leading-relaxed max-w-md">
              프리미엄 헬멧 블루투스 오디오 시스템. 속도 위에 펼쳐지는 선율, 라이딩의 품격을 격상시킵니다.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: "ri-instagram-line", label: "Instagram" },
                { icon: "ri-youtube-line", label: "YouTube" },
                { icon: "ri-kakao-talk-line", label: "KakaoTalk" },
                { icon: "ri-facebook-circle-line", label: "Facebook" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  rel="nofollow"
                  aria-label={s.label}
                  className="w-10 h-10 flex items-center justify-center rounded-md border border-background-700 hover:border-primary-500 hover:text-primary-400 cursor-pointer transition-colors"
                >
                  <i className={s.icon}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 tracking-widest">
              제품
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#product" className="hover:text-primary-400 cursor-pointer">X9 PRO</a></li>
              <li><a href="#features" className="hover:text-primary-400 cursor-pointer">주요 기능</a></li>
              <li><a href="#specs" className="hover:text-primary-400 cursor-pointer">기술 스펙</a></li>
              <li><a href="#buy" className="hover:text-primary-400 cursor-pointer">구매처</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 tracking-widest">
              고객지원
            </h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><a href="#faq" className="hover:text-primary-400 cursor-pointer">자주 묻는 질문</a></li>
              <li><a href="#manual" className="hover:text-primary-400 cursor-pointer">디지털 설명서</a></li>
              <li><a href="#install" className="hover:text-primary-400 cursor-pointer">설치 가이드</a></li>
              <li><a href="#contact" className="hover:text-primary-400 cursor-pointer">1:1 문의</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 md:mt-14 pt-8 border-t border-background-800/60 grid grid-cols-1 md:grid-cols-12 gap-8 text-xs text-background-400">
          <div className="md:col-span-5 space-y-1.5">
            <h5 className="text-sm font-bold text-background-50 uppercase tracking-wider mb-2">고객만족센터 & A/S</h5>
            <p className="text-base font-bold text-primary-400 font-mono">032-668-8723 내선1번</p>
            <p>운영 시간: 평일 10:00 - 17:00 (점심시간 12:00 - 13:00)</p>
            <p>주말 및 공휴일 휴무 / 게시판 상담 항시 이용 가능</p>
            <div className="mt-3 p-3 bg-background-900/50 border border-background-800/60 rounded-xl">
              <p className="font-bold text-background-200 text-[11px] mb-0.5">LRGS Premium Care Warranty</p>
              <p className="text-[10px] leading-relaxed">1년 무상 교환 혜택 제공 (기본 기기 결함 고장 발생 시)</p>
            </div>
          </div>
          <div className="md:col-span-4 space-y-1.5">
            <h5 className="text-sm font-bold text-background-50 uppercase tracking-wider mb-2">(주)엘알지에스원</h5>
            <p>대표이사: 양우석 | 인천시 부평구 경인로1083</p>
            <p>사업자등록번호: 848-88-04032</p>
            <p>개인정보보호책임자: 양우석 (nixnix111@naver.com)</p>
            <p>호스팅 제공자: (주)엘알지에스원</p>
          </div>
          <div className="md:col-span-3 space-y-2">
            <h5 className="text-sm font-bold text-background-50 uppercase tracking-wider mb-2">약관 및 고지</h5>
            <ul className="space-y-2">
              <li><a href="#" className="hover:text-primary-400 cursor-pointer" rel="nofollow">이용약관</a></li>
              <li><a href="#" className="hover:text-primary-400 cursor-pointer font-bold text-primary-400" rel="nofollow">개인정보처리방침</a></li>
              <li><a href="#" className="hover:text-primary-400 cursor-pointer" rel="nofollow">정품인증 및 워런티 고지</a></li>
              <li><a href="#" className="hover:text-primary-400 cursor-pointer" rel="nofollow">공식 딜러망 개설 문의</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-800/60 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[11px] text-background-400 font-mono">
          <p>© 2026 LRGS1. All Rights Reserved.</p>
          <p>Designed with Luxury Minimal Precision.</p>
        </div>
      </div>
    </footer>
  );
}